import {IBox} from '@elproag/predict';
import type {DescriptionsProps} from 'antd';
import {Descriptions} from 'antd';
import React, {useContext} from 'react';
import DateTimeUtils from '../../Infrastructure/DateTime/DateTimeUtils';
import {AuthContext} from '../../../common/context';
import {FormatAsOutUnit} from '../../../common/util/MeasurementValueUtils';

interface IBoxTableProps {
	box: IBox;
}

export function BoxTable(props: Readonly<IBoxTableProps>): React.ReactElement {
	const authContext = useContext(AuthContext);

	const items: DescriptionsProps['items'] = [
		{key: 'name', label: 'Name', children: props.box.name},
		{key: 'provider', label: 'Provider', children: props.box.provider},
		{
			key: 'payloadRangeMin',
			label: 'Payload Range Min',
			children: FormatAsOutUnit(props.box.payloadRangeMin, authContext.Organization.DefaultTemperature),
		},
		{
			key: 'payloadRangeMax',
			label: 'Payload Range Max',
			children: FormatAsOutUnit(props.box.payloadRangeMax, authContext.Organization.DefaultTemperature),
		},
		{
			key: 'qualifiedDurationInSeconds',
			label: 'Qualified Duration',
			children: DateTimeUtils.formatSecondsAsDuration(props.box.qualifiedDurationSeconds),
		},
		{key: 'volume', label: 'Volume', children: `${props.box.volume} m³`},
	];

	return <Descriptions items={items} bordered={false} column={{xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2}} size={'small'} />;
}
